import { SpinResponse } from '@cgs/data-access';
import { Container } from '@cgs/wge';
import { IInitialReelsProvider } from '../reels_engine/game_components_providers/i_icons_enumerator_provider';
import {
  T_IGameParams,
  T_IInitialReelsProvider,
  T_ISlotGameEngineProvider,
} from '../type_definitions';
import { SlotParams } from '../reels_engine/slot_params';
import { ISlotGameEngineProvider } from '../reels_engine/game_components_providers/i_slot_game_engine_provider';
import { ISlotGameEngine } from '../reels_engine/i_slot_game_engine';
import { ReelsEngine } from '../reels_engine/reels_engine';

export const FALLBACK_MACHINE_STATE_SERVICE_TOKEN = Symbol('FALLBACK_MACHINE_STATE_SERVICE_TOKEN');

export class FallbackMachineStateService {
  private readonly initialReelsProvider: IInitialReelsProvider;
  private readonly slotParams: SlotParams;
  private readonly gameEngine: ISlotGameEngine;

  constructor(container: Container) {
    this.initialReelsProvider = container.resolve<IInitialReelsProvider>(T_IInitialReelsProvider);
    this.slotParams = container.resolve<SlotParams>(T_IGameParams);
    this.gameEngine =
      container.resolve<ISlotGameEngineProvider>(T_ISlotGameEngineProvider).gameEngine;
  }

  public getSpinMachineState(): SpinResponse {
    return this.getMachineState();
  }

  public getBuyFeatureMachineState(): SpinResponse {
    return this.getMachineState();
  }

  public getBonusMachineState(): SpinResponse {
    return this.getMachineState();
  }

  public getGamblesMachineState(): SpinResponse {
    return this.getMachineState();
  }

  protected getMachineState(): SpinResponse {
    let initialIcons: number[][] = [];

    if (this.gameEngine instanceof ReelsEngine) {
      initialIcons = this.initialReelsProvider.getInitialReelsForFakeResponse(
        this.slotParams.groupsCount,
        this.slotParams.maxIconsPerGroup,
        this.gameEngine.internalConfig
      );
    }

    const result = new SpinResponse();
    result.viewReels = initialIcons;
    result.bonusInfo = null;
    result.scatterInfo = null;
    result.freeSpinsInfo = null;
    result.winLines = [];
    result.winPositions = [];
    result.specialSymbolGroups = [];
    result.totalWin = 0;
    result.totalLost = 0;
    result.bigWinName = '';
    result.isFakeResponse = true;

    return result;
  }
}
